import { render, staticRenderFns } from "./CoachProfile.vue?vue&type=template&id=2ef9f65e&scoped=true&"
import script from "./CoachProfile.vue?vue&type=script&lang=js&"
export * from "./CoachProfile.vue?vue&type=script&lang=js&"
import style0 from "./CoachProfile.vue?vue&type=style&index=0&id=2ef9f65e&lang=scss&scoped=true&"
import style1 from "./CoachProfile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9f65e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VFooter,VSheet})
